// Test IDs for the Dashboard overview page.

export const DASHBOARD = {
        welcomeTitle: 'dashboard-welcome-title',
        statProfessionals: 'dashboard-stat-professionals',
        statServices: 'dashboard-stat-services',
        statPatients: 'dashboard-stat-patients',
        statAppointments: 'dashboard-stat-appointments',
        statTeam: 'dashboard-stat-team',
};
